export default {
  props: {
    collections: {
      type: Array,
      default: () => [],
    },
    isCheckBoxes: {
      type: Boolean,
      default: false,
    },
    isLoading: Boolean,
  },
  data() {
    return {
      placeholderCount: 16,
    };
  },
  watch: {
    collections() {},
    isLoading() {},
  },
};
